<div id="layout">
  <div>
    <header>
      <h2>
        {{ source?.name }} @if (source?.type) {
        <span>- {{ source?.type }}</span>
        }
      </h2>

      @if (source && !isProductionMode && source.type !== 'oneteam') {
      <div
        class="ui primary background button"
        [ngClass]="{
          loading: isSaving,
          disabled: source.type === 'csv' && !hasTableQ()
        }"
        (click)="save()"
      >
        {{ "settings.save" | transloco }}
      </div>
      }
    </header>

    <div id="year-row">
      <div>
        @if (taxYearOptions) {
        <app-search-dropdown
          label="{{ yearLabel }}"
          [formGroup]="searchForm"
          [formCtrl]="taxYear"
          [listOptions]="taxYearOptions"
        ></app-search-dropdown>
        }
      </div>

      @if (source && !isProductionMode && source.type !== 'oneteam') {
      <div id="new-question-column">
        @if (lang === 'en') {
        <input
          type="file"
          #sourceTemplateUpload
          id="list-upload-btn"
          btn-name="Upload Source Template"
          (change)="initFile($event.target.files)"
        />
        } @if (lang === 'ja') {
        <input
          type="file"
          #sourceTemplateUpload
          id="list-upload-btn-ja"
          btn-name="ソース テンプレートのアップロード"
          (change)="initFile($event.target.files)"
        />
        }
        <div class="ui primary background button" (click)="addNewQuestion()">
          {{ "settings.add-new-question" | transloco }}
        </div>
      </div>
      }
    </div>

    @if (source?.sourceQuestions?.length == 0) {
    <div id="no-results">
      {{ "settings.no-source-questions-found" | transloco }}
    </div>
    }
  </div>
  @if (errorMessage) {
  <div class="error-message">{{ errorMessage }}</div>
  } @if (!loading && source?.sourceQuestions?.length > 0) {
  <div id="table-scroll-cont">
    <div id="table-cont">
      <table id="list" width="100%" cellspacing="0">
        <thead>
          <tr>
            @if (source.type !=='csv') {
            <td width="50px">{{ "settings.external-id" | transloco }}</td>
            }
            <td width="1px">{{ "settings.rubix-id" | transloco }}</td>
            <td width="200px">{{ "settings.question-name" | transloco }}</td>
            <td width="1px">{{ "settings.data-type" | transloco }}</td>
            <td width="1px">{{ "settings.table" | transloco }}</td>
            @if (source.type!=='csv') {
            <td width="1px">{{ "settings.column" | transloco }}</td>
            } @if (source.type!=='csv') {
            <td width="1px">{{ "settings.group" | transloco }}</td>
            } @if (source.type!=='csv') {
            <td width="1px">{{ "settings.parent-question" | transloco }}</td>
            }
            <td width="1px">{{ "settings.mandatory" | transloco }}</td>
            <td width="1px">{{ "settings.spouse" | transloco }}</td>
            <td width="1px">{{ "settings.format" | transloco }}</td>
            @if (showConfig) {
            <td width="1px">{{ "settings.config" | transloco }}</td>
            } @if (oneTeamIntegrationEnabled) {
            <td width="1px">{{ "settings.include-in-wizard" | transloco }}</td>
            } @if (oneTeamIntegrationEnabled) {
            <td width="1px">
              {{ "settings.ot-alternative-names" | transloco }} (|
              {{ "settings.separated" | transloco }})
            </td>
            } @if (oneTeamIntegrationEnabled) {
            <td width="1px">
              {{ "settings.ot-template-header-required" | transloco }}
            </td>
            } @if (oneTeamIntegrationEnabled) {
            <td width="1px">
              {{ "settings.ot-sum-to-zero-validation" | transloco }}
            </td>
            } @if (oneTeamIntegrationEnabled) {
            <td width="1px">
              {{ "settings.ot-entity-match-column" | transloco }}
            </td>
            }
            <td width="1px"></td>
          </tr>
        </thead>
        <tbody>
          @for (question of source?.sourceQuestions; track question; let index =
          $index) {
          <tr
            [ngClass]="{
              active: question.edit,
              disabled: question.status !== 0
            }"
          >
            @if (source.type !=='csv') {
            <td
              (click)="editValue(question, $event)"
              class="external-id truncated-text"
            >
              <div>
                @if (!question.edit) {
                <div
                  textTruncate
                  length="10"
                  [text]="question.externalIdentifier"
                  title="{{ question.externalIdentifier }}"
                  class="truncate-text"
                ></div>
                }
                <i [hidden]="question.edit" class="pencil icon"></i>
                <div [hidden]="!question.edit">
                  <input
                    type="text"
                    [(ngModel)]="question.externalIdentifier"
                  />
                </div>
              </div>
            </td>
            }
            <td class="question-id">{{ question.id || "NEW" }}</td>
            <td
              (click)="editValue(question, $event)"
              class="name truncated-text"
            >
              <div>
                @if (!question.edit) {
                <div
                  textTruncate
                  length="30"
                  [text]="question.question"
                  title="{{ question.question }}"
                  class="truncate-text"
                ></div>
                }
                <i [hidden]="question.edit" class="pencil icon"></i>
                <div [hidden]="!question.edit">
                  <input type="text" [(ngModel)]="question.question" />
                </div>
              </div>
            </td>
            <td
              (click)="!question.isTable && editValue(question, $event)"
              class="data-type"
            >
              <div [hidden]="question.edit">
                {{ question.dataType }}
                @if (!question.isTable) {
                <i class="pencil icon"></i>
                }
              </div>
              <div [hidden]="!question.edit || question.isTable">
                <div>
                  <div class="ui search selection datatype dropdown">
                    <input class="search" autocomplete="off" />
                    <div class="text"></div>
                    <div class="menu"></div>
                    <i class="chevron down icon"></i>
                  </div>
                </div>
              </div>
            </td>
            <td class="is-table">
              <div
                class="ui checkbox"
                [ngClass]="{ disabled: tableColumnIsDisabled(question) }"
                (click)="!question.id && canSelectTable(question)"
              >
                <input
                  type="checkbox"
                  [(ngModel)]="question.isTable"
                  [disabled]="question.id"
                />
                <label></label>
              </div>
            </td>
            @if (source.type!=='csv') {
            <td class="is-column">
              <div class="ui checkbox" [hidden]="question.isTable">
                <input
                  type="checkbox"
                  [(ngModel)]="question.isTableColumn"
                  [disabled]="question.id"
                />
                <label></label>
              </div>
            </td>
            } @if (source.type!=='csv') {
            <td class="is-group">
              <div class="ui checkbox">
                <input
                  type="checkbox"
                  [(ngModel)]="question.inGroup"
                  [disabled]="source.type === 'oneteam'"
                />
                <label></label>
              </div>
            </td>
            } @if (source.type!=='csv') {
            <td
              (click)="editValue(question, $event)"
              class="parent-question truncated-text"
            >
              <div [hidden]="question.isTable">
                @if (!question.edit) {
                <div
                  textTruncate
                  length="15"
                  [text]="question.parentQuestion"
                  title="{{ question.parentQuestion }}"
                  class="truncate-text"
                ></div>
                } @if (!question.edit &&
                (question.parentQuestion===null||!question.parentQuestion) &&
                (question.isTableColumn||question.inGroup)) {
                <div class="error">{{ "settings.required" | transloco }}</div>
                }
                <i [hidden]="question.edit" class="pencil icon"></i>
                <div [hidden]="!question.edit" style="width: 100%">
                  <div class="ui search selection parent-question dropdown">
                    <input class="search" autocomplete="off" />
                    <div class="text"></div>
                    <div class="menu"></div>
                    <i class="chevron down icon"></i>
                  </div>
                </div>
              </div>
            </td>
            }
            <td class="is-mandatory">
              <div class="ui checkbox" [hidden]="question.isTable">
                <input type="checkbox" [(ngModel)]="question.mandatory" />
                <label></label>
              </div>
            </td>
            <td class="is-spouse">
              <div class="ui checkbox" [hidden]="question.isTable">
                <input type="checkbox" [(ngModel)]="question.spouse" />
                <label></label>
              </div>
            </td>
            <td
              (click)="!question.isTable && editValue(question, $event)"
              class="format truncated-text"
            >
              <div [hidden]="question.isTable">
                @if (!question.edit) {
                <div
                  textTruncate
                  length="15"
                  [text]="question.sourceFormat"
                  title="{{ question.sourceFormat }}"
                  class="truncate-text"
                ></div>
                } @if (!question.edit && !question.sourceFormat &&
                question.dataType==='date') {
                <div class="error">{{ "settings.required" | transloco }}</div>
                }
                <i [hidden]="question.edit" class="pencil icon"></i>
                <div [hidden]="!question.edit">
                  <input type="text" [(ngModel)]="question.sourceFormat" />
                </div>
              </div>
            </td>
            @if (showConfig) {
            <td
              (click)="editValue(question, $event)"
              class="name truncated-text"
            >
              <div>
                @if (!question.edit) {
                <div
                  textTruncate
                  length="30"
                  [text]="question.config"
                  title="{{ question.config }}"
                  class="truncate-text"
                ></div>
                }
                <i [hidden]="question.edit" class="pencil icon"></i>
                <div [hidden]="!question.edit">
                  <input type="text" [(ngModel)]="question.config" />
                </div>
              </div>
            </td>
            } @if (oneTeamIntegrationEnabled) {
            <td>
              <div
                class="ui checkbox"
                [hidden]="
                  !source.enableDataStandardisation ||
                  question.isTable ||
                  question.dataType === 'image' ||
                  question.dataType === 'file'
                "
              >
                <input type="checkbox" [(ngModel)]="question.includeInWizard" />
              </div>
            </td>
            } @if (oneTeamIntegrationEnabled) {
            <td
              (click)="
                !(
                  !source.enableDataStandardisation ||
                  question.isTable ||
                  question.dataType === 'image' ||
                  question.dataType === 'file'
                ) && editValue(question, $event)
              "
              class="data-type"
            >
              <div
                [hidden]="
                  !source.enableDataStandardisation ||
                  question.isTable ||
                  question.dataType === 'image' ||
                  question.dataType === 'file'
                "
              >
                @if (!question.edit) {
                <div
                  textTruncate
                  length="15"
                  [text]="question.alternativeNames"
                  title="{{ question.alternativeNames }}"
                  class="truncate-text"
                ></div>
                }
                <i [hidden]="question.edit" class="pencil icon"></i>
                <div [hidden]="!question.edit">
                  <input type="text" [(ngModel)]="question.alternativeNames" />
                </div>
              </div>
            </td>
            } @if (oneTeamIntegrationEnabled) {
            <td>
              <div
                class="ui checkbox"
                [hidden]="
                  !source.enableDataStandardisation ||
                  question.isTable ||
                  question.dataType === 'image' ||
                  question.dataType === 'file'
                "
              >
                <input
                  type="checkbox"
                  [(ngModel)]="question.templateHeaderRequired"
                />
              </div>
            </td>
            } @if (oneTeamIntegrationEnabled) {
            <td>
              <div
                class="ui checkbox"
                [hidden]="
                  !source.enableDataStandardisation ||
                  question.isTable ||
                  question.dataType === 'image' ||
                  question.dataType === 'file'
                "
              >
                <input type="checkbox" [(ngModel)]="question.sumToZero" />
              </div>
            </td>
            } @if (oneTeamIntegrationEnabled) {
            <td>
              <div
                class="ui checkbox"
                [hidden]="
                  !source.enableDataStandardisation ||
                  question.isTable ||
                  question.dataType === 'image' ||
                  question.dataType === 'file'
                "
              >
                <input type="checkbox" [(ngModel)]="question.entityMatch" />
              </div>
            </td>
            }
            <td class="actions">
              @if (question.status == 0 && !isProductionMode) {
              <div
                (click)="deleteQuestion(question, index)"
                class="delete icon"
              ></div>
              } @if (question.status !== 0 && !isProductionMode) {
              <i
                (click)="reActivateQuestion(question)"
                class="redo icon"
                title="Re-activate question"
              ></i>
              }
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    @if (isLoadingTemplate) {
    <div class="ui active centered inline loader"></div>
    }
  </div>
  }
</div>

<div
  #sourceQuestionUploadWarningsModal
  id="source-question-upload-warnings-modal"
  class="ui tiny modal"
>
  <h1>{{ "settings.Warning" | transloco }}</h1>

  <div class="content">
    <p>
      {{ 'settings.Question-{{sourceQuestionsWithWarning
      }}-has-the-same-name-as-previously-deleted-question' | transloco :
      {sourceQuestionsWithWarning} }}
    </p>
  </div>

  <div class="actions">
    <div class="ui primary background approve button">
      {{ "settings.Close-Warnings" | transloco }}
    </div>
  </div>
</div>
